import * as THREE from 'three';

export const assembly = {
  board: new THREE.MeshBasicMaterial({
    color: 0x332B17,
    order: 0,
  }),
  bottomsilkscreen: new THREE.MeshBasicMaterial({
    color: 0xffffff,
  }),
  bottomsoldermask: new THREE.MeshBasicMaterial({
    color: 0x006600,
    opacity: 0.75,
    transparent: true,
  }),
  topsilkscreen: new THREE.MeshBasicMaterial({
    color: 0xffffff,
    order: 3,
  }),
  topsoldermask: new THREE.MeshBasicMaterial({
    color: 0x006600,
    opacity: 0.75,
    transmission: 0.75,
    transparent: true,
    order: 2,
  }),
  partSelected: new THREE.MeshStandardMaterial({
    color: 0xFF0000,
    opacity: 0.60,
    transparent: true,
    order: 4,
  }),
  partPlaced: new THREE.MeshStandardMaterial({
    color: 0x666666,
    opacity: 1.0,
    transparent: false,
    order: 4,
  }),
  partNotPlaced: new THREE.MeshStandardMaterial({
    color: 0xEEEEEE,
    opacity: 0.60,
    transparent: true,
    order: 4,
  }),
  note: new THREE.MeshBasicMaterial({ color: 0xFF2222 }),
  pin1: new THREE.MeshBasicMaterial({ color: 0x4990E9 }),
};
export const assemblyHasl = {
  bottomlayer: new THREE.MeshBasicMaterial({
    color: 0xA9A9A9,
  }),
  toplayer: new THREE.MeshBasicMaterial({
    color: 0xA9A9A9,
    order: 1,
  }),
  drills: new THREE.MeshBasicMaterial({
    color: 0xA9A9A9,
  }),
};
Object.assign(assemblyHasl, assembly);

export const assemblyEnig = {
  bottomlayer: new THREE.MeshBasicMaterial({
    color: 0xFFBD00,
  }),
  toplayer: new THREE.MeshBasicMaterial({
    color: 0xFFBD00,
  }),
  drills: new THREE.MeshBasicMaterial({
    color: 0xFFBD00,
  }),
};
Object.assign(assemblyEnig, assembly);

export const layout = {
  board: new THREE.MeshBasicMaterial({
    color: 0x666666,
  }),
  boardoutline: new THREE.LineBasicMaterial({ color: new THREE.Color('rgb(255,165,0)'), linewidth: 1.0 }),
  toplayer: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(179, 71, 77)'),
    opacity: 0.85,
    transparent: true,
  }),
  internalplane1: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(235, 203, 139)'),
    opacity: 0.85,
    transparent: true,
  }),
  internalplane2: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(163, 190, 140)'),
    opacity: 0.85,
    transparent: true,
  }),
  internalplane3: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(194, 0, 0)'),
    opacity: 0.85,
    transparent: true,
  }),
  internalplane4: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(0, 132, 132)'),
    opacity: 0.85,
    transparent: true,
  }),
  internalplane5: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(111, 66, 193)'),
    opacity: 0.85,
    transparent: true,
  }),
  internalplane6: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(226, 157, 83)'),
    opacity: 0.85,
    transparent: true,
  }),
  bottomlayer: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(94, 129, 172)'),
    opacity: 0.85,
    transparent: true,
  }),
  topsilkscreen: new THREE.MeshBasicMaterial(),
  bottomsilkscreen: new THREE.MeshBasicMaterial(),
  topsoldermask: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(216, 222, 233)'),
    opacity: 0.25,
    transparent: true,
  }),
  bottomsoldermask: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(216, 222, 233)'),
    opacity: 0.25,
    transparent: true,
  }),
  holes: new THREE.MeshBasicMaterial({
    color: '#4990E9',
  }),
  drills: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(216, 222, 233)'),
  }),
  millinglv1: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(148, 80, 160)'),
    opacity: 0.85,
    transparent: true,
  }),
  millinglv2: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(148, 80, 160)'),
    opacity: 0.95,
    transparent: true,
  }),
  note: new THREE.MeshBasicMaterial({ color: 0xFF4444 }),
};

export const layoutReal = {
  board: new THREE.MeshBasicMaterial({
    color: 0x5d4a1b,
  }),
  boardoutline: new THREE.MeshBasicMaterial({
    color: 0x666666,
  }),
  topsilkscreen: new THREE.MeshBasicMaterial({
    color: 0xFFFFFF,
  }),
  bottomsilkscreen: new THREE.MeshBasicMaterial({
    color: 0xFFFFFF,
  }),
  topsoldermask: new THREE.MeshBasicMaterial({
    color: 0x006600,
    opacity: 0.75,
    transparent: true,
  }),
  bottomsoldermask: new THREE.MeshBasicMaterial({
    color: 0x006600,
    opacity: 0.75,
    transparent: true,
  }),
  toppaste: new THREE.MeshBasicMaterial({
    color: 0x666666,
    opacity: 0.9,
    transparent: true,
  }),
  bottompaste: new THREE.MeshBasicMaterial({
    color: 0x666666,
    opacity: 0.9,
    transparent: true,
  }),
  holes: new THREE.MeshBasicMaterial({
    color: '#4990E9',
    opacity: 0.75,
    transparent: true,
  }),
  millinglv1: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(148, 80, 160)'),
    opacity: 0.85,
    transparent: true,
  }),
  millinglv2: new THREE.MeshBasicMaterial({
    color: new THREE.Color('rgb(148, 80, 160)'),
    opacity: 0.95,
    transparent: true,
  }),
  note: new THREE.MeshBasicMaterial({ color: 0xFF4444 }),
};

export const layoutRealHasl = {
  toplayer: new THREE.MeshStandardMaterial({
    color: 0xA9A9A9,
  }),
  bottomlayer: new THREE.MeshStandardMaterial({
    color: 0xA9A9A9,
  }),
  drills: new THREE.MeshStandardMaterial({
    color: 0xA9A9A9,
  }),
};
Object.assign(layoutRealHasl, layoutReal);

export const layoutRealEnig = {
  toplayer: new THREE.MeshStandardMaterial({
    color: 0xFFBD00,
  }),
  bottomlayer: new THREE.MeshStandardMaterial({
    color: 0xFFBD00,
  }),
  drills: new THREE.MeshStandardMaterial({
    color: 0xFFBD00,
  }),
};
Object.assign(layoutRealEnig, layoutReal);
